/** VDB 스냅샷만 생성 (attach-vse 제출 전, update-viewr 스킵). */
export const EDITOR_LIBRARY_ATTACH_PRECONVERSION_SAVE_REASON =
  "editor_library_attach_preconversion";

/** @deprecated attach-vse 정본 경로에서는 사용하지 않음. */
export const EDITOR_LIBRARY_ATTACH_PERSIST_REASON = "editor_library_attach_persist";

export type EditorLibraryAttachSession = {
  uploadItemId: string;
  jobId: string;
  libraryObjectId: string;
  libraryVseGcsPath: string;
  libraryVsePublicUrl: string;
  viewrGcsPath: string;
  targetSpaceIndex: number;
  expectedVseIndex: number;
  displayName: string;
  saveAttemptId?: string | null;
};

const sessionsByUploadItemId = new Map<string, EditorLibraryAttachSession>();
let activePersistSaveAttemptId: string | null = null;

export function registerEditorLibraryAttachSession(
  session: EditorLibraryAttachSession,
): void {
  sessionsByUploadItemId.set(session.uploadItemId, session);
}

export function getEditorLibraryAttachSession(
  uploadItemId: string,
): EditorLibraryAttachSession | null {
  return sessionsByUploadItemId.get(uploadItemId) ?? null;
}

export function clearEditorLibraryAttachSession(uploadItemId: string): void {
  sessionsByUploadItemId.delete(uploadItemId);
  if (
    activePersistSaveAttemptId &&
    sessionsByUploadItemId.size === 0
  ) {
    activePersistSaveAttemptId = null;
  }
}

export function bindLibraryAttachPersistSaveAttempt(
  uploadItemId: string,
  saveAttemptId: string,
): void {
  const session = sessionsByUploadItemId.get(uploadItemId);
  if (!session) return;
  session.saveAttemptId = saveAttemptId;
  activePersistSaveAttemptId = saveAttemptId;
}

export function resolveLibraryAttachUsageForSave({
  reason,
  saveAttemptId,
}: {
  reason?: string | null;
  saveAttemptId?: string | null;
}): {
  usedVseGcsPaths: string[];
  usedLibraryObjectIds: string[];
} | null {
  if (reason !== EDITOR_LIBRARY_ATTACH_PERSIST_REASON) {
    return null;
  }

  const normalizedAttemptId = (saveAttemptId ?? "").trim();
  if (normalizedAttemptId) {
    for (const session of Array.from(sessionsByUploadItemId.values())) {
      if (session.saveAttemptId === normalizedAttemptId) {
        return {
          usedVseGcsPaths: [session.libraryVseGcsPath],
          usedLibraryObjectIds: [session.libraryObjectId],
        };
      }
    }
  }

  if (activePersistSaveAttemptId) {
    for (const session of Array.from(sessionsByUploadItemId.values())) {
      if (session.saveAttemptId === activePersistSaveAttemptId) {
        return {
          usedVseGcsPaths: [session.libraryVseGcsPath],
          usedLibraryObjectIds: [session.libraryObjectId],
        };
      }
    }
  }

  const first = Array.from(sessionsByUploadItemId.values())[0] as
    | EditorLibraryAttachSession
    | undefined;
  if (!first) return null;
  return {
    usedVseGcsPaths: [first.libraryVseGcsPath],
    usedLibraryObjectIds: [first.libraryObjectId],
  };
}
